module.exports = __webpack_public_path__ + "media/images/moov-money-be94654b79f73a8fbaa874509f13d390.png";